import hash from "object-hash";
import _ from "underscore";
import {DocumentAmendment} from "common/flowmaster/types/amendment";

export default function hashAmendment(amendment: DocumentAmendment): string {
  return hash(_.omit(amendment, ["issue_id", "llm_run_id", "creation_date"]));
}
